import React from "react";
import Marquee from "react-fast-marquee";
import { useLanguage } from "../../i18n/LanguageContext";

export const EditorialMarquee = () => {
  const { t, lang } = useLanguage();
  return (
    <section
      className="border-y border-[#7B1113]/8 bg-[#F6F2EA] py-8 md:py-10"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <Marquee key={lang} speed={38} gradient={false} autoFill className="marquee-mask">
        {t.marquee.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="px-8 text-2xl font-medium tracking-tight text-[#2A1112] md:text-4xl">
              {item}
            </span>
            <span className="text-2xl text-[#F5A623] md:text-4xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export default EditorialMarquee;
